"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _detectBrowser = require("detect-browser");

var _Error = _interopRequireDefault(require("./../Messages/Error"));

var _ValidationIcons = _interopRequireDefault(require("./../Inputs/ValidationIcons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TimeInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      name = _ref.name,
      disabled = _ref.disabled,
      error = _ref.error,
      touched = _ref.touched,
      isHour = _ref.isHour,
      isMinute = _ref.isMinute,
      isSecond = _ref.isSecond,
      is12HourFormat = _ref.is12HourFormat,
      value = _ref.value,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["className", "name", "disabled", "error", "touched", "isHour", "isMinute", "isSecond", "is12HourFormat", "value", "onBlur", "onChange", "children"]);

  var _useReducer = (0, _react.useReducer)(function (state, _ref2) {
    var type = _ref2.type,
        payload = _ref2.payload;

    switch (type) {
      case 'hour':
        return _extends({}, state, {
          hour: payload
        });

      case 'minute':
        return _extends({}, state, {
          minute: payload
        });

      case 'second':
        return _extends({}, state, {
          second: payload
        });

      default:
        return _extends({}, state);
    }
  }, _extends({}, value)),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      time = _useReducer2[0],
      dispatch = _useReducer2[1];

  var browser = (0, _detectBrowser.detect)();

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = (0, _react.useState)('1rem'),
      _useState4 = _slicedToArray(_useState3, 2),
      iconRight = _useState4[0],
      setIconRight = _useState4[1];

  var _useState5 = (0, _react.useState)(is12HourFormat ? 'am' : ''),
      _useState6 = _slicedToArray(_useState5, 2),
      timeFormat = _useState6[0],
      setTimeFormat = _useState6[1];

  var hourRef = (0, _react.useRef)();
  var minuteRef = (0, _react.useRef)();
  var secondRef = (0, _react.useRef)();
  var ARROW_LEFT = 37;
  var ARROW_UP = 38;
  var ARROW_RIGHT = 39;
  var ARROW_DOWN = 40;

  var isTime = function isTime() {
    if (!time || !Object.keys(time).length) return;
    var t = '';
    if (isHour) t = time.hour;
    if (isMinute) t = t ? "".concat(t, ":").concat(time.minute) : time.minute;
    if (isSecond) t = t ? "".concat(t, ":").concat(time.second) : time.second;
    return t.length > 5 ? /\d{2}:\d{2}:\d{2}/.test(t) : /\d{2}:\d{2}/.test(t);
  };

  (0, _react.useEffect)(function () {
    if (!isTime()) return;
    onChange({
      name: name,
      value: "".concat(time.hour, ":").concat(time.minute, ":").concat(time.second).concat(timeFormat)
    });
    !touched && setFocus(false);
  }, [time.hour, time.minute, time.second, isTime, name, touched, onChange, timeFormat]);
  var prevRef = {
    hour: null,
    minute: hourRef,
    second: minuteRef
  };
  var nextRef = {
    hour: minuteRef,
    minute: secondRef,
    second: null
  }; // Pad the value -> pad(4) returns '04', pad(11) returns '11'

  var pad = function pad(n, type) {
    if (type === 'hour' && !parseInt(n)) return '01';
    if (parseInt(n) < 0) return '00';
    return parseInt(n) < 10 ? "0".concat(parseInt(n)) : n;
  }; // Change focus to the field with the classname in the nextField argument


  var focusField = function focusField(field) {
    if (!field) return;
    field.current.focus();
    field.current.setSelectionRange(0, field.current.getAttribute('data-maxlengthvalue'));
  };

  var setRange = function setRange(e) {
    e.preventDefault();
    e.target.setSelectionRange(0, e.target.getAttribute('data-maxlengthvalue'));
  };

  var keyDownHandler = function keyDownHandler(e, max, min) {
    if (![8, 37, 38, 39, 40].includes(e.keyCode)) return true;
    var type = e.target.id;
    e.preventDefault();

    if (e.keyCode === ARROW_UP || e.keyCode === ARROW_DOWN) {
      if (time[type] === '' && type === 'hour') return dispatch({
        type: type,
        payload: '01'
      });else if (time[type] === '') return dispatch({
        type: type,
        payload: '00'
      });
      if (parseInt(time[type]) < min || parseInt(time[type]) > max) return false;

      if (e.keyCode === ARROW_UP && parseInt(time[type]) <= max) {
        var num = parseInt(time[type]);

        if (type === 'hour' && timeFormat === 'am') {
          dispatch({
            type: type,
            payload: num === max ? '01' : pad(num + 1)
          });
          num === max && setTimeFormat('pm');
        } else num < max && dispatch({
          type: type,
          payload: pad(num + 1, type)
        });
      } else if (e.keyCode === ARROW_DOWN && parseInt(time[type]) >= min) {
        var _num = parseInt(time[type]);

        if (type === 'hour' && timeFormat === 'pm') {
          dispatch({
            type: type,
            payload: _num === min ? '12' : pad(_num - 1)
          });
          _num === min && setTimeFormat('am');
        } else dispatch({
          type: type,
          payload: pad(_num - 1, type)
        });
      }
    } else if ([ARROW_LEFT, 8].includes(e.keyCode)) {
      focusField(prevRef[type]);
      e.keyCode === 8 && dispatch({
        type: type,
        payload: ''
      });
    } else if (ARROW_RIGHT === e.keyCode) {
      focusField(nextRef[type]);
    }

    setRange(e);
  };

  var handleFocus = function handleFocus() {
    setFocus(true);
    if (!browser) return;

    switch (browser.name) {
      case ['', 'safari'].includes(browser.name):
        setIconRight('3.5rem');
        break;

      default:
        setIconRight('1rem');
    }
  }; // Single functions to handle all blurs


  var blurHandlerType = function blurHandlerType(_ref3, max, min) {
    var id = _ref3.id,
        value = _ref3.value;
    if (value === '') return false;
    var inRange = parseInt(value) <= max && parseInt(value) >= min;
    var tempInput = inRange ? pad(value, id) : pad(time[id][0], id);
    dispatch({
      type: id,
      payload: tempInput
    });
  };

  var handleBlurInput = function handleBlurInput(_ref4) {
    var _ref4$target = _ref4.target,
        id = _ref4$target.id,
        value = _ref4$target.value;

    switch (id) {
      case 'hour':
        blurHandlerType({
          id: id,
          value: value
        }, is12HourFormat ? 12 : 24, 0);
        break;

      case 'minute':
        blurHandlerType({
          id: id,
          value: value
        }, 59, 0);
        break;

      case 'second':
        blurHandlerType({
          id: id,
          value: value
        }, 59, 0);
    }
  };

  var handleChangedInputForType = function handleChangedInputForType(_ref5) {
    var id = _ref5.id,
        value = _ref5.value,
        max = _ref5.max,
        min = _ref5.min;
    var type = id;
    var tempValue;
    if (isNaN(value)) tempValue = pad(isNaN(time[type]) ? 1 : time[type], type);else if (parseInt(value) < min || parseInt(value) > max) {
      tempValue = time[type] ? time[type] : 1;
    } else tempValue = value;
    dispatch({
      type: type,
      payload: tempValue
    });
    value.length === 2 && focusField(nextRef[type]);
  };

  var handleChangedInput = function handleChangedInput(e) {
    if (!/^\d{1,2}$/.test(e.target.value)) return;
    e.persist();
    handleChangedInputForType(e.target);
  };

  var onFocus = function onFocus(_ref6) {
    var target = _ref6.target;
    target.setSelectionRange(0, target.getAttribute('data-maxlengthvalue'));
  };

  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    className: className,
    ref: ref
  }, otherProps), /*#__PURE__*/_react.default.createElement(StyledLabel, {
    disabled: disabled,
    htmlFor: name
  }, children, /*#__PURE__*/_react.default.createElement(Input, {
    error: error,
    touched: touched,
    onFocus: handleFocus,
    onBlur: onBlur
  }, isHour ? /*#__PURE__*/_react.default.createElement(StyledSingleInputTime, {
    id: "hour",
    value: time.hour,
    "data-maxlengthvalue": 2,
    maxLength: 2,
    max: is12HourFormat ? 12 : 24,
    onBlur: handleBlurInput,
    onChange: handleChangedInput,
    placeholder: "HH",
    type: "text",
    autoComplete: "off",
    ref: hourRef,
    onFocus: onFocus,
    min: 1,
    onKeyDown: function onKeyDown(e) {
      return keyDownHandler(e, is12HourFormat ? 12 : 24, 1);
    }
  }) : null, ':', isMinute ? /*#__PURE__*/_react.default.createElement(StyledSingleInputTime, {
    id: "minute",
    value: time.minute,
    "data-maxlengthvalue": 2,
    maxLength: 2,
    max: 59,
    onBlur: handleBlurInput,
    onChange: handleChangedInput,
    placeholder: "MM",
    type: "text",
    ref: minuteRef,
    autoComplete: "off",
    onFocus: onFocus,
    min: 0,
    onKeyDown: function onKeyDown(e) {
      return keyDownHandler(e, 59, 0);
    }
  }) : null, ':', isSecond ? /*#__PURE__*/_react.default.createElement(StyledSingleInputTime, {
    id: "second",
    value: time.second,
    maxLength: 4,
    max: 59,
    "data-maxlengthvalue": 2,
    ref: secondRef,
    onBlur: handleBlurInput,
    onChange: handleChangedInput,
    placeholder: "SS",
    type: "text",
    autoComplete: "off",
    onFocus: onFocus,
    minLength: 1,
    min: 0,
    onKeyDown: function onKeyDown(e) {
      return keyDownHandler(e, 59, 0);
    }
  }) : null, timeFormat), /*#__PURE__*/_react.default.createElement(_ValidationIcons.default, {
    error: error,
    browser: browser,
    focus: focus,
    iconRight: iconRight,
    touched: touched
  })), /*#__PURE__*/_react.default.createElement(_Error.default, {
    error: error
  }));
});

var Input = _styledComponents.default.div.withConfig({
  displayName: "Input"
})(["display:flex;align-items:center;position:relative;font-size:1.5rem;width:100%;box-sizing:border-box;overflow:hidden;justify-content:flex-start;background-color:white;padding-left:1.2rem;height:4rem;margin-top:0.8rem;border:0.1rem solid;border-color:", ";border-radius:0.3rem;"], function (_ref7) {
  var error = _ref7.error,
      touched = _ref7.touched,
      theme = _ref7.theme;
  return error ? theme.status.error : touched && !error ? theme.status.succes : theme.ui.outline;
});

Input.displayName = 'Input';

var StyledLabel = _styledComponents.default.label.withConfig({
  displayName: "StyledLabel"
})(["display:flex;flex-direction:column;position:relative;width:100%;font-size:1.4rem;color:", ";"], function (_ref8) {
  var disabled = _ref8.disabled,
      theme = _ref8.theme;
  return disabled ? theme.ui.disabled : theme.labels.guaranteeText;
});

var StyledSingleInputTime = _styledComponents.default.input.withConfig({
  displayName: "StyledSingleInputTime"
})(["flex-grow:0;flex-shrink:0;width:2.9rem;border:none;letter-spacing:0.1rem;align-items:center;background-color:rgba(0,0,0,0);display:block;padding:0.2rem;text-align:center;font-size:1.5rem;&:focus{outline:none;}&::placeholder{letter-spacing:0;}"]);

StyledSingleInputTime.displayName = 'SingleInputTime';

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container"
})(["width:100%;font-family:", ";position:relative;height:9rem;"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.font;
});

Container.displayName = 'Container';
TimeInput.displayName = 'TimeInput';
TimeInput.defaultProps = {
  disabled: false,
  touched: false,
  otherProps: {},
  value: {
    hour: '',
    minute: '',
    second: ''
  },
  isHour: true,
  isMinute: true,
  isSecond: true,
  is12HourFormat: true,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {}
};
TimeInput.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** name of input and label */
  name: _propTypes.string.isRequired,

  /** label above the input */
  children: _propTypes.node.isRequired,

  /** type of input: email, text, ... */
  disabled: _propTypes.bool,

  /** example value in the input */
  error: _propTypes.string,

  /** object with inputname and boolean to check if touched */
  touched: _propTypes.bool,

  /** Callback function that is fired when blurring the input field. */
  onBlur: _propTypes.func,

  /** Callback function that is fired when focusing the input field. */
  onChange: _propTypes.func,

  /** Callback function that is fired when the component's value changes. */
  onFocus: _propTypes.func,

  /** Current value of the input element as { hour: 'hh', minute: 'mm', second: 'ss' } */
  value: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
    hour: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    minute: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    second: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  })]),

  /** Adds extra props to the element */
  otherProps: _propTypes.object,
  isHour: _propTypes.bool,
  isMinute: _propTypes.bool,
  isSecond: _propTypes.bool,
  is12HourFormat: _propTypes.bool
};
var _default = TimeInput;
exports.default = _default;